export const ProblemDocumentDropFilters = Object.freeze({
	problem: "dd1",
});
